var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var Model = require('../../libs/Model');
var modal = require('../../layout/components/modal');
var formGroup = require('../../components/formGroup');
var ToggleSwitch = require('../../components/toggleSwitch');

var editClassDatasetModal = Object.create(Model);

function trimString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

function isTruthyFlag(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1';
  }
  return false;
}

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


editClassDatasetModal.editDialogue = function (datasetDefinition, options) {
  editClassDatasetModal.datasetDefinition = datasetDefinition;
  editClassDatasetModal.modifiedDatasetDefinition = prop(JSON.parse(JSON.stringify(datasetDefinition)));
  editClassDatasetModal.newImageSelected = prop(false);
  editClassDatasetModal.newImagePreviewUrl = prop(false);
  editClassDatasetModal.errors = [];

  var submit = async function () {
    editClassDatasetModal.errors = [];
    var datasetName = trimString(editClassDatasetModal.modifiedDatasetDefinition().name);
    if(!datasetName) {
      editClassDatasetModal.errors.push('Datasets should have a name');
      throw new Error('Datasets should have a name');
    }
    editClassDatasetModal.modifiedDatasetDefinition().name = datasetName;
    Object.assign(editClassDatasetModal.datasetDefinition, editClassDatasetModal.modifiedDatasetDefinition());
    if (options && options.submitCallback) {
      await options.submitCallback(editClassDatasetModal.datasetDefinition);
    }
    modal.vm.close();
  };

  key.setScope('modal');
  key('enter', 'modal', submit);

  modal.vm.title(`Edit ${datasetDefinition.name}: `)
  modal.vm.body = editClassDatasetModal.view,
  modal.vm.buttons([
    {
      label: "Submit",
      class: "btn-good",
      func: submit
    }
  ]);
  modal.vm.open();
}


editClassDatasetModal.view = function () {

  if (!editClassDatasetModal.modifiedDatasetDefinition().type) {
    editClassDatasetModal.modifiedDatasetDefinition().type = 'list';
  }

  if (!editClassDatasetModal.modifiedDatasetDefinition().width ) {
    editClassDatasetModal.modifiedDatasetDefinition().width = 1;
  }
  return  m('form', {role:'form'}, [
    editClassDatasetModal.errorView(),
    m(formGroup, [
      m('label', 'Name'),
      m('input.form-control', {
        type:'text', 
        oninput: function(ev){editClassDatasetModal.modifiedDatasetDefinition().name = ev.target.value},
        value: editClassDatasetModal.modifiedDatasetDefinition().name,
        readonly: editClassDatasetModal.modifiedDatasetDefinition().name == 'Default' ? true : false,
      })
    ]),
    m(formGroup, [
      m('label', 'URL'),
      m('input.form-control', {
        type:'text', 
        oninput: function(ev){editClassDatasetModal.modifiedDatasetDefinition().url = ev.target.value},
        value: editClassDatasetModal.modifiedDatasetDefinition().url,
      })
    ]),
    m(formGroup, [
      m('label', 'Type'),
      m('select.form-control', {
        onchange: function(ev){editClassDatasetModal.modifiedDatasetDefinition().type = ev.target.value},
        value: editClassDatasetModal.modifiedDatasetDefinition().type,
      }, [
        m("option", {value:"list"}, "List"),
        m("option", {value:"gauge"}, "Gauge"),
        m("option", {value:"chart"}, "Chart"),
        m("option", {value:"chartwithpoint"}, "Chart With Point"),
        m("option", {value:"spacer"}, "Spacer"),
        m("option", {value:"img"}, "Image"),
        m("option", {value:"text"}, "Text"),
      ]),
    ]),
    (function () {
      if (editClassDatasetModal.modifiedDatasetDefinition().type === 'spacer') {
        editClassDatasetModal.modifiedDatasetDefinition().width = 4;
      } else {
        return m(formGroup, [
          m("label", "Width"),
          m("select.form-control", {
            onchange: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().width = ev.target.value },
            value: editClassDatasetModal.modifiedDatasetDefinition().width,
          }, [
            m("option", {value:1}, "Single"),
            m("option", {value:2}, "Double"),
            m("option", {value:3}, "Three Quarter"),
            m("option", {value:4}, "Full")
          ]),
        ])
      }
    })(),
    (function () {
      if (editClassDatasetModal.modifiedDatasetDefinition().type === 'img' || editClassDatasetModal.modifiedDatasetDefinition().type === 'graphic') {
        
        return m(formGroup, [
          m("label", "Src"),
          m('input.form-control', {
            type: 'file',
            accept: 'image/*',
            style: {background: 'transparent', border: 'none'},
            onchange: function (e) {
                if (e.target.files && e.target.files[0]) {
                    editClassDatasetModal.newImageSelected(true);
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        var imagePreview = document.getElementById('image-preview');
                        if (imagePreview) {
                            imagePreview.srcPath = event.target.result;
                            imagePreview.style.display = 'block'; // Make the image visible
                        }
                        m.redraw(); // Force Mithril to update the DOM
                    }
                    reader.readAsDataURL(e.target.files[0]);
                    editClassDatasetModal.modifiedDatasetDefinition().srcPath = e.target.files[0];
                    editClassDatasetModal.newImagePreviewUrl = URL.createObjectURL(e.target.files[0]);
                }
            }
          }),
          editClassDatasetModal.newImageSelected() ?
            m('img.h5', {
              style: { heigth: '14rem' },
              src: editClassDatasetModal.newImagePreviewUrl,
              alt: 'New Image Preview'
            })
          :
            editClassDatasetModal.datasetDefinition.srcPath ?
              m('img.h5', {
                style: { height: '14rem' },
                src: `/api/v1/ontology/classimage/${editClassDatasetModal.datasetDefinition.name}?type=equipment&src=${encodeURIComponent(editClassDatasetModal.datasetDefinition.srcPath)}`, 
                alt: 'Equipment Class Image',
              })
              : 
                ''
        ])
          
      }
    })(),
    (function () {
      if (editClassDatasetModal.modifiedDatasetDefinition().type === 'chart' || editClassDatasetModal.modifiedDatasetDefinition().type === 'smallchart') {
        return m(formGroup, [
          m("label", "Span"),
          m("input.form-control", {
            type:"number",
            autocomplete: 'off',
            oninput: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().chartSpan = ev.target.value },
            value: editClassDatasetModal.modifiedDatasetDefinition().chartSpan,
          }),
          m("label", "Chart Resample"),
          m("select.form-control", {
            onchange: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().chartResample = ev.target.value },
            value: editClassDatasetModal.modifiedDatasetDefinition().chartResample,
          }, [
            m("option", {value:"hour"}, "Hour"),
            m("option", {value:"hours"}, "Hours"),
            m("option", {value:"days"}, "Days"),
            m("option", {value:"minutes"}, "Minutes")
          ]),
          m(formGroup, [
            m('label', 'Y Maximum'),
            m('input.form-control', {
              type:'number', 
              oninput: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().yMax = ev.target.value},
              value: editClassDatasetModal.modifiedDatasetDefinition().yMax,
            })
          ]),
          m(formGroup, [
            m('label', 'Y Minimum'),
            m('input.form-control', {
              type:'number', 
              oninput: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().yMin = ev.target.value },
              value: editClassDatasetModal.modifiedDatasetDefinition().yMin,
            })
          ])
        ]);
      } else {
        return '';
      }
    })(),
    (function () {
      if (editClassDatasetModal.modifiedDatasetDefinition().type === 'spacer') {
        return m(formGroup, [
          m("label", "Label"),
          m("input.form-control", {
            type:"text",
            autocomplete: 'off',
            oninput: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().label = ev.target.value },
            value: editClassDatasetModal.modifiedDatasetDefinition().label,
          }),
          m("label", "Display As "),
          m("select.form-control", {
            onchange: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().dividerType = ev.target.value },
            value: editClassDatasetModal.modifiedDatasetDefinition().dividerType,
          }, [
            m("option", {value:"blank"}, "Hidden"),
            m("option", {value:"line"}, "Line")
          ]),
        ]);
      } else {
        return '';
      }
    })(),
    (function () {
      if (editClassDatasetModal.modifiedDatasetDefinition().type === 'text') {
        if (!editClassDatasetModal.modifiedDatasetDefinition().height) {
          editClassDatasetModal.modifiedDatasetDefinition().height = "2";
        }
        return [
          m(formGroup, [
            m("label", "Markdown Text"),
            m('textarea', {
              resize: 'none',
              id:'comment',
              rows:'5',
              cols:'40', 
              'box-sizing': 'border-box',
              placeholder:"Add your markdown text here...",
              oninput: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().markdownText = ev.target.value },
              value: editClassDatasetModal.modifiedDatasetDefinition().markdownText,
            })
          ]),
          m(formGroup, [
            m("label", "Height"),
            m("select.form-control", {
              onchange: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().height = ev.target.value },
              value: editClassDatasetModal.modifiedDatasetDefinition().height,
            }, [
              m("option", {value:"1"}, "None"),
              m("option", {value:"2"}, "Single"),
              m("option", {value:"3"}, "Double"),
              m("option", {value:"4"}, "Full")
            ]),
          ])
        ];
      } else {
        return '';
      }
    })(),
    (()=>{
      if (
        editClassDatasetModal.modifiedDatasetDefinition().type === 'gauge' &&
        Array.isArray(editClassDatasetModal.modifiedDatasetDefinition().columns) &&
        editClassDatasetModal.modifiedDatasetDefinition().columns.length > 0
      ) {
        editClassDatasetModal.modifiedDatasetDefinition().columns.length = 1;
        console.log(editClassDatasetModal.modifiedDatasetDefinition().columns);
      }
    })(),
    m('div.form-group', [
      m('name', 'Help text'),
      m('textarea', {
        resize: 'none',
        id:'comment',
        rows:'5',
        cols:'40', 
        'box-sizing': 'border-box',
        placeholder:"Add your help markdown text here...",
        oninput: function(ev) { editClassDatasetModal.modifiedDatasetDefinition().helpText = ev.target.value },
        value: editClassDatasetModal.modifiedDatasetDefinition().helpText,
      })
    ]),
    m('div.mr1.w-100.mb2.flex.justify-between', [
      m('label',`Show In Summary`),
      m(ToggleSwitch, {
        id: 'check_showInSummary',
        checked: isTruthyFlag(editClassDatasetModal.modifiedDatasetDefinition().showInSummary),
        ariaLabel: 'Show in summary',
        onchange: function (ev) {
          editClassDatasetModal.modifiedDatasetDefinition().showInSummary = ev.target.checked ? 'true' : 'false';
        }
      })
    ]),
    m('div.mr1.w-100.mb2.flex.justify-between', [
      m('label',`Hide In Diagram`),
      m(ToggleSwitch, {
        id: 'check_hideInDiagram',
        checked: isTruthyFlag(editClassDatasetModal.modifiedDatasetDefinition().hideInDiagram),
        ariaLabel: 'Hide in diagram',
        onchange: function (ev) {
          editClassDatasetModal.modifiedDatasetDefinition().hideInDiagram = ev.target.checked ? 'true' : 'false';
        }
      })
    ]),
    m('div.mr1.w-100.mb2.flex.justify-between', [
      m('label',`External Diagrams`),
      m(ToggleSwitch, {
        id: 'check_hideInParentDiagram',
        checked: isTruthyFlag(editClassDatasetModal.modifiedDatasetDefinition().hideInParentDiagram),
        ariaLabel: 'External diagrams',
        onchange: function (ev) {
          editClassDatasetModal.modifiedDatasetDefinition().hideInParentDiagram = ev.target.checked ? 'true' : 'false';
        }
      })
    ]),
    m('div.mr1.w-100.mb2.flex.justify-between', [
      m('label',`Hide In Equipment Detail`),
      m(ToggleSwitch, {
        id: 'check_hideInEquipmentDetail',
        checked: isTruthyFlag(editClassDatasetModal.modifiedDatasetDefinition().hideInEquipmentDetail),
        ariaLabel: 'Hide in equipment detail',
        onchange: function (ev) {
          editClassDatasetModal.modifiedDatasetDefinition().hideInEquipmentDetail = ev.target.checked ? 'true' : 'false';
        }
      })
    ]),
    m('div.mr1.w-100.mb2.flex.justify-between', [
      m('label',`Hide In Parent Equipment Detail`),
      m(ToggleSwitch, {
        id: 'check_hideInParentEquipmentDetail',
        checked: isTruthyFlag(editClassDatasetModal.modifiedDatasetDefinition().hideInParentEquipmentDetail),
        ariaLabel: 'Hide in parent equipment detail',
        onchange: function (ev) {
          editClassDatasetModal.modifiedDatasetDefinition().hideInParentEquipmentDetail = ev.target.checked ? 'true' : 'false';
        }
      })
    ]),
    m('div.mr1.w-100.mb2.flex.justify-between', [
      m('label',`Hide On Map`),
      m(ToggleSwitch, {
        id: 'check_hideOnMap',
        checked: isTruthyFlag(editClassDatasetModal.modifiedDatasetDefinition().hideOnMap),
        ariaLabel: 'Hide on map',
        onchange: function (ev) {
          editClassDatasetModal.modifiedDatasetDefinition().hideOnMap = ev.target.checked ? 'true' : 'false';
        }
      })
    ])
  ]);
}

module.exports = editClassDatasetModal;
